export default __webpack_public_path__ + "static/media/delivery-icon.96d1bef4.svg";